export const SET_NEW_COMMENT = "SET_NEW_COMMENT";

export const POST_NEW_COMMENT_LOADING = "POST_NEW_COMMENT_LOADING";
export const POST_NEW_COMMENT_SUCCESS = "POST_NEW_COMMENT_SUCCESS";

export const PROCESS_COMMENT_FAILURE = "PROCESS_COMMENT_FAILURE";

export const GET_COMMENT_LOADING = "GET_COMMENT_LOADING";
export const GET_COMMENT_SUCCESS = "GET_COMMENT_SUCCESS";

export const QUERY_LATEST_COMMENTS_SUCCESS = "QUERY_LATEST_COMMENTS_SUCCESS";
